import React from 'react'
import style from './dash-icon.style.module.css';

function DashIcon(props) {
    return (
      <>
        <div className={style.container}>
          {props.img?<img src="/images/common/icons/bullet-letstalk.png" alt="Dash Icon" title='Dash Icon' />:<div className={style.dashIcon} style={props.inputStyle}/>}
        </div>
      </>
    )
  }

export default DashIcon